import { ChakraDivider as Divider, ChakraStack as Stack, ChakraHeading as Heading } from "@airhelp/react-ui-components";
import { renderDynamicComponent } from "modules/storyblok/DynamicComponent";
import { WhyChooseListItem } from "../WhyChooseListItem";
import type { WhyChooseAirHelpCardProps } from "../WhyChooseAirHelp.d";
import { WhyChooseList } from "../WhyChooseList";

export const WhyChooseCard = ({ title, items, button, backgroundColor }: WhyChooseAirHelpCardProps) => {
  const mobileWidth = "calc(100vw - 32px)";

  return (
    <Stack
      flexDir="column"
      p={{ base: 0, md: 6, lg: 8 }}
      borderRadius={{ base: "none", md: "lg" }}
      w={{ base: "100%", md: "45vw" }}
      maxWidth={{ base: mobileWidth, md: "452px" }}
      textAlign="left"
      backgroundColor={{ base: "unset", md: backgroundColor }}
      position="relative"
      spacing={8}
    >
      <Heading variant="h4" as="h4">
        {title}
      </Heading>
      <Divider display={{ base: "none", md: "block" }} />
      <WhyChooseList>
        {items.map((item) => (
          <WhyChooseListItem key={item._uid} item={item} />
        ))}
      </WhyChooseList>
      {button && renderDynamicComponent(button)}
    </Stack>
  );
};
